import * as React from 'react';
//import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Container, Row, Col, Modal, InputGroup, Form, FormControl, Card, Accordion } from 'react-bootstrap';
import { Link } from 'react-router-dom';
//import Swal from 'sweetalert2'
//import PullJobConfigTable from './PullJobConfigTable'
import * as GetLogModel from '../../models/Logger'
import { FaSearch, FaCheckCircle, FaTimesCircle, FaPlayCircle, FaFolderOpen, FaAngleDown, FaPlusCircle, FaFileExport } from "react-icons/fa";
//import Tab from 'react-bootstrap/Tab';
//import Tabs from 'react-bootstrap/Tabs';

import LogTable from './LogTable'
import { Button } from '@chakra-ui/react';
//import LogTableRawView from './LogTableRawView'

class Logger extends React.Component<any, { key: string, SearchLoggerReq: GetLogModel.SearchLoggerReq }> {

    constructor(props: any) {
        super(props);
        this.state = {
            key: "",
            SearchLoggerReq: {
                function_name: '',
                action: '',
                log_type: '',
                legacy_id: '',
                created_by: '',
                created_on: '',
            },
        }
        this.callbackReset = this.callbackReset.bind(this)
    }

    handleChangeSearchInput = (e: any, key: string) => {
        if (key !== "") {
            var data = this.state.SearchLoggerReq
            data[key] = e.target.value
            this.setState({
                SearchLoggerReq: data
            })
        }
    }

    public callbackReset() {
        this.setState({
            key: ''
        })
    }

    Reset = () => {
        console.log('Reset function')
        this.setState({
            key: 'Reset'
        })
    }

    handleClearInput = (key: string) => {
        console.log(key)
        if (key !== "") {
            var data = JSON.parse(JSON.stringify(this.state.SearchLoggerReq))
            data[key] = ""
            this.setState({
                SearchLoggerReq: data
            })
        }
    }

    render() {
        return (
            <div>
                {/* Page title */}
                <div className="mt-2">
                    <div className='trapezoid' style={{ width: 'auto', display: 'inline-block' }}>
                        <span className="employee-font font-size-employee">
                            ADM-DMS107 DMS Log
                        </span>
                    </div>
                </div>

                <div className="mat-box employee-font font-size-employee">
                    <Row>
                        <Col>
                            <Row className="trapezoid trapezoid-purple" style={{ margin: 'initial' }}>
                                <span style={{ fontSize: '15px' }}>Search Menu</span>
                            </Row>
                            <Card.Body
                                className="mat-box shadow"
                                style={{ borderColor: '#e5e6e9 #dfe0e4 #d0d1d5', borderStyle: 'solid', borderWidth: '1px' }}
                            >
                                <Row className="mt-2">
                                    <Col lg="6">
                                        <Form className="mb-3" as={Row}>
                                            <Form.Label column sm="3" className="text-center">Function Name :</Form.Label>
                                            <Col sm="9">
                                                <InputGroup>
                                                    <Form.Control type="text" size='sm' value={this.state.SearchLoggerReq.function_name} onChange={(e) => this.handleChangeSearchInput(e, 'function_name')} />
                                                    <Button variant="outline-secondary" size="sm" onClick={() => this.handleClearInput('function_name')}><FaTimesCircle /></Button>
                                                </InputGroup>
                                            </Col>
                                        </Form>
                                    </Col>
                                    <Col lg="6">
                                        <Form className="mb-3" as={Row}>
                                            <Form.Label column sm="3" className="text-center">Legacy ID :</Form.Label>
                                            <Col sm="9">
                                                <InputGroup>
                                                    <Form.Control type="text" size='sm' value={this.state.SearchLoggerReq.legacy_id} onChange={(e) => this.handleChangeSearchInput(e, 'legacy_id')} />
                                                    <Button variant="outline-secondary" size="sm" onClick={() => this.handleClearInput('legacy_id')}><FaTimesCircle /></Button>
                                                </InputGroup>
                                            </Col>
                                        </Form>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg="6">
                                        <Form className="mb-3" as={Row}>
                                            <Form.Label column sm="3" className="text-center">Action :</Form.Label>
                                            <Col sm="9">
                                                <InputGroup>
                                                    <Form.Control type="text" size='sm' value={this.state.SearchLoggerReq.action} onChange={(e) => this.handleChangeSearchInput(e, 'action')} />
                                                    <Button variant="outline-secondary" size="sm" onClick={() => this.handleClearInput('action')}><FaTimesCircle /></Button>
                                                </InputGroup>
                                            </Col>
                                        </Form>
                                    </Col>
                                    <Col lg="6">
                                        <Form className="mb-3" as={Row}>
                                            <Form.Label column sm="3" className="text-center">Log Type :</Form.Label>
                                            <Col sm="9">
                                                <InputGroup>
                                                    <Form.Control type="text" size='sm' value={this.state.SearchLoggerReq.log_type} onChange={(e) => this.handleChangeSearchInput(e, 'log_type')} />
                                                    <Button variant="outline-secondary" size="sm" onClick={() => this.handleClearInput('log_type')}><FaTimesCircle /></Button>
                                                </InputGroup>
                                            </Col>
                                        </Form>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg="6">
                                        <Form className="mb-3" as={Row}>
                                            <Form.Label column sm="3" className="text-center">Create By :</Form.Label>
                                            <Col sm="9">
                                                <InputGroup>
                                                    <Form.Control type="text" size='sm' value={this.state.SearchLoggerReq.created_by} onChange={(e) => this.handleChangeSearchInput(e, 'created_by')} />
                                                    <Button variant="outline-secondary" size="sm" onClick={() => this.handleClearInput('created_by')}><FaTimesCircle /></Button>
                                                </InputGroup>
                                            </Col>
                                        </Form>
                                    </Col>
                                    <Col lg="6">
                                        <Form className="mb-3" as={Row}>
                                            <Form.Label column sm="3" className="text-center">Time Stamp :</Form.Label>
                                            <Col sm="9">
                                                <InputGroup>
                                                    <Form.Control type="date" size='sm' value={this.state.SearchLoggerReq.created_on} onChange={(e) => this.handleChangeSearchInput(e, 'created_on')} />
                                                    <Button variant="outline-secondary" size="sm" onClick={() => this.handleClearInput('created_on')}><FaTimesCircle /></Button>
                                                </InputGroup>
                                            </Col>
                                        </Form>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="d-flex justify-content-end">
                                        <Button
                                            leftIcon={<FaSearch />}
                                            colorScheme="green"
                                            size="sm"
                                            onClick={this.Reset}
                                        >
                                            ค้นหา
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Col>
                    </Row>

                    <LogTable checkkey={this.state.key} callbackkey={this.callbackReset.bind(this)} searchLoggerReq={this.state.SearchLoggerReq} />
                </div>
            </div>
        )
    }

}
export default Logger